import { CheckCircle, XCircle, AlertCircle, Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Modal from './Modal'

const iconMap = {
  success: CheckCircle,
  error: XCircle,
  warning: AlertCircle,
  info: Info,
}

const colorMap = {
  success: 'text-green-600',
  error: 'text-red-600',
  warning: 'text-yellow-600',
  info: 'text-blue-600',
}

const defaultTitleKeyMap = {
  success: 'modal.common.success',
  error: 'modal.common.error',
  warning: 'modal.common.warning',
  info: 'modal.common.info',
}

export default function MessageModal({ isOpen, onClose, type = 'info', title, message }) {
  const { t } = useTranslation()
  if (!isOpen) return null

  const Icon = iconMap[type] || iconMap.info
  const iconColor = colorMap[type] || colorMap.info
  const resolvedTitle = title || t(defaultTitleKeyMap[type] || defaultTitleKeyMap.info)

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={resolvedTitle}>
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 ${iconColor}`}>
          <Icon className="w-8 h-8" />
        </div>
        <div className="flex-1">
          <p className="text-gray-700">{message}</p>
        </div>
      </div>
      <div className="mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="btn btn-primary"
        >
          {t('modal.common.ok')}
        </button>
      </div>
    </Modal>
  )
}
